var _ = require('underscore')
  , $ = require('jquery')

var validateFuncs = {
  '[data-required]': function validateRequired(input) {
    return !!$.trim(input.val()).length
  }
, '[data-type="qq"]': function validateRequired(input) {
    var value = input.val()
    if (!value) { return true }

    var rQQ = /^[1-9][0-9]{4,}$/i;
    return rQQ.test(value)
  }
, '[data-type="telephone"]': function validateRequired(input) {
    var value = input.val()
    if (!value) { return true }
    var rTelephone = /^((\(\d{3}\))|(\d{3}\-))?1[345789]\d{9}$/i;
    return rTelephone.test(value)
  }
, '[data-type="email"]': function validateRequired(input) {
    var value = input.val()
    if (!value) { return true }

    var rEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/i;
    return rEmail.test(value)
  }
, '[data-max-length]': function validateRequired(input) {
    var value = input.val()
    if (!value) { return true }

    return value.length <= input.data('max-length')
  }
}

var invalidMsgs = {
  '[data-required]': '<%= label %>为必填项'
, '[data-type="qq"]': 'QQ 号码格式不正确'
, '[data-type="telephone"]': '手机号码格式不正确'
, '[data-type="email"]': '邮箱格式不正确'
, '[data-max-length]': function(input) {
    return '<%= label %>最多只能输入' + input.data('max-length') + '个字'
  }
}

function ValidateForm(options) {
  options = options || {}
  this.form = options.form
  this.inputs = this.form.find('[data-validate]')
  this.validateFuncs = validateFuncs
  this.invalidMsgs = invalidMsgs
  this.fieldErrors = [];
}


ValidateForm.prototype.validate = function() {

  var isValid = true
  this.fieldErrors = []

  this.inputs.each($.proxy(function(i, el) {
    el = $(el)
    if (!this.validateElem(el)) {
      isValid = false
    }
  }, this))

  return isValid
}

ValidateForm.prototype.validateElem = function(el) {
  el = $(el)
  var invalidMsgs = this.invalidMsgs
    , val = $.trim(el.val())

  el.val(val)

  return _.every(this.validateFuncs, function(validator, selector) {
    if (!el.is(selector)) { return true }

    var valid = validator(el)

    if (valid) { return true }

    var invalidMsg = invalidMsgs[selector]

    if (_.isFunction(invalidMsg)) { invalidMsg = invalidMsg(el) }

    var label = el.data('label')
      , errorMessage = _.template(invalidMsg)({ label: label })

    this.handleInvalid(el, errorMessage)

    return false
  }, this)
}

ValidateForm.prototype.handleInvalid = function(input, errorMessage) {
  this.fieldErrors.push({
    input: input
  , message: errorMessage
  })

  var formItem = input.closest('.form-group')

  formItem.css('border-color', 'red')

  input.one('change input', function() {
    formItem.css('border-color', '#e6e6e6')
  })
}

module.exports = ValidateForm
